"use client";

import styled from "styled-components";

export const List = styled.ul`
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const ListItem = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  padding: 15px 1.5rem;
  width: 100%;
  height: auto;

  @media (min-width: 768px) {
    height: 75px;
    padding: 10px 1.5rem;
    gap: 10px;
  }

  &:nth-child(even) {
    background-color: var(--grayCard);
  }
`;
